module.exports = __webpack_public_path__ + "img/eng_logo.8f24e52c.png";